export default "__VITE_PUBLIC_ASSET__bdc326cf__"